import _ from 'lodash';



export const isProd = _.includes([
  'prod',
  'production'
], _.toLower(process.env.REACT_APP_ENV_NAME ?? ''));
